import { render, staticRenderFns } from "./AtasDirex.vue?vue&type=template&id=48757b66"
import script from "./AtasDirex.vue?vue&type=script&lang=js"
export * from "./AtasDirex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports